import {svgIconWrapper} from '../svg-icon-wrapper';

import CheckRegular from './check-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CheckRegular {...validProps} />;
}

SvgComponent.iconName = 'checkRegular';

export const CheckRegularIcon = svgIconWrapper(SvgComponent);
